import { useToast, Skeleton } from '@chakra-ui/react';
import React from 'react';

import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { useGetCreditAgreementDocumentsMetadataQuery } from 'packages/creditAgreements/requests/requests.gql.generated';
import CreditAgreementTable from 'packages/creditAgreements/ui/CreditAgreementsTable';

const CreditAgreements: React.FC = () => {
  const { creditFacilityId } = useCreditFacilityContext();

  const toast = useToast();

  const creditAgreementInfoPathGenerator = (id: string) =>
    `/credit-agreements/${id}`;

  const {
    data: creditAgreementDocumentsMetadataData,
  } = useGetCreditAgreementDocumentsMetadataQuery({
    variables: {
      creditFacilityId,
    },
    onError: () => {
      toast({
        title: `Error loading credit agreements.`,
        status: 'error',
        position: 'top',
        isClosable: true,
      });
    },
    fetchPolicy: 'network-only',
  });

  if (!creditAgreementDocumentsMetadataData) {
    return <Skeleton />;
  }

  const creditAgreementDocumentsMetadata =
    creditAgreementDocumentsMetadataData.creditAgreementDocumentsMetadata;

  return (
    <CreditAgreementTable
      creditAgreementDocumentsMetadata={creditAgreementDocumentsMetadata}
      creditFacilityId={creditFacilityId}
      creditAgreementInfoPathGenerator={creditAgreementInfoPathGenerator}
    />
  );
};

export default CreditAgreements;
